module.exports = __webpack_public_path__ + "static/media/fav.63066a05.svg";